import CarrotClient from "./index"
import Settings from "../../utils/CarrotConfig"
import { IOSMobileBridgeClient } from "./mobileNativeClients/IOSMobileBridgeClient"
import { AndroidMobileBridgeClient } from "./mobileNativeClients/AndroidMobileBridgeClient"
import { getGlobal } from "./mobileNativeClients/shared"
import { NullMobileBridgeClient } from "./mobileNativeClients/NullMobileBridgeClient"

const isIOSNativeApp = () => IOSMobileBridgeClient.isIOSMobileClient()
const isAndroidNativeApp = () => AndroidMobileBridgeClient.isAndroidMobileClient()
const isMobileApp = () => isIOSNativeApp() || isAndroidNativeApp()
const isBiometricsCapable = async () => await getBridge().isBiometricsCapable()
const isBiometricLoginAlreadyConfigured = () => getBridge().isBiometricLoginAlreadyConfigured()
const disableBiometrics = () => getBridge().disableBiometrics()
// @ts-expect-error TS7006
const attemptBiometricsCredentialsRetrieval = async (login) =>
  await getBridge().attemptBiometricsCredentialsRetrieval(login)
// @ts-expect-error TS7006
const showBiometricsEnrollment = (username, password, biometricEnrollmentSuccess, biometricEnrollmentFailure) =>
  getBridge().showBiometricsEnrollment(username, password, biometricEnrollmentSuccess, biometricEnrollmentFailure)

// @ts-expect-error TS7031
const IfNotMobileNative = ({ children }) => {
  if (isMobileApp()) {
    return null
  }

  return children
}

// @ts-expect-error TS7031
const IfMobileNative = ({ children }) => {
  if (!isMobileApp()) {
    return null
  }

  return children
}

// @ts-expect-error TS7031
const IfIosNative = ({ children }) => {
  if (!isIOSNativeApp()) {
    return null
  }

  return children
}

const isMobileNativeAndBiometricsCapable = async () => isMobileApp() && (await isBiometricsCapable())

const shouldAttemptBioAuthenticationLogin = async () =>
  isMobileApp() && (await isBiometricsCapable()) && (await isBiometricLoginAlreadyConfigured())

// @ts-expect-error TS7006
const goToMobileHelpCenter = async (link) => {
  // @ts-expect-error TS7009
  const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
  const token = await client.getZendeskMobileAuthToken()

  // parse link: sections/4410088379931-Carrot-Plans
  const [zdType, articleSlug] = link ? link.split("/") : []
  const [id] = articleSlug ? articleSlug.split("-") : []

  getBridge().helpCenter(token, zdType, id)
}

const getBridge = () => {
  if (!isMobileApp()) return new NullMobileBridgeClient()

  return isIOSNativeApp() ? new IOSMobileBridgeClient() : new AndroidMobileBridgeClient()
}

// Temporary test functions //////////////////////////////////////////////////////////
getGlobal().testIsBiometricsCapable = async () => {
  const isCapable = await getBridge().isBiometricsCapable()
  // eslint-disable-next-line no-console
  console.log(`Should be last: isCapable: ${isCapable}`)
}

getGlobal().testIsBiometricLoginAlreadyConfigured = async () => {
  const isBiometricLoginAlreadyConfigured = await getBridge().isBiometricLoginAlreadyConfigured()
  // eslint-disable-next-line no-console
  console.log(`Should be last: isBiometricLoginAlreadyConfigured: ${isBiometricLoginAlreadyConfigured}`)
}

getGlobal().testDisableBiometrics = async () => {
  await getBridge().disableBiometrics()
}
// End Temporary test functions //////////////////////////////////////////////////////////

export {
  isMobileApp,
  goToMobileHelpCenter,
  isIOSNativeApp,
  isAndroidNativeApp,
  IfNotMobileNative,
  IfMobileNative,
  IfIosNative,
  isBiometricsCapable,
  isBiometricLoginAlreadyConfigured,
  disableBiometrics,
  attemptBiometricsCredentialsRetrieval,
  showBiometricsEnrollment,
  shouldAttemptBioAuthenticationLogin,
  isMobileNativeAndBiometricsCapable
}
